function renderSidebar() {
	let data = {
		box: $('[data-sidebar="box"]'),
		bars: $('[data-sidebar="bars"]'),
		toggleItems: $('[data-sidebar="toggle-subitem"]'),
		opener: $('[data-sidebar="opener"]'),
		closer: $('[data-sidebar="closer"]')
	};

	$.each(data.toggleItems, function () {
		let subitems = $(this).find('.sidebar__subitems');

		$(this).on('click', function () {
			subitems.slideToggle();
		});

		$(this).on('mouseenter', function () {
			subitems.slideDown();
		});
	});

	data.opener.on('click', function () {
		data.box.addClass('is--active');
		data.bars.addClass('is--removed');
	});
	
	data.closer.on('click', function () {
		data.box.removeClass('is--active');
		data.bars.removeClass('is--removed');
	});
}